<template>
	<div :class="classes">
		<h4>{{ potentialDate.timeStamp | fullDateTime }}</h4>
		<div class="communication-appointment-fan--appointment-confirmation">
			{{ potentialDate.confirmed ? 'Bestätigt' : 'Noch nicht bestätigt' }}
		</div>
		<h2 v-if="isListTypeApplicant">{{ potentialDate.jobProfile.info }}</h2>
		<h2 v-else>{{ potentialDate.disclosedData.nameWithSalutation }}</h2>
		<AppointmentInfos
			:appointment="potentialDate.appointment"
			:type="appointmentInfosType"
			@sentAccessLink="$emit('sentAccessLink')"
		/>
		<div class="communication-appointment-fan--appointment-actions">
			<div>
				<Button
					v-if="!potentialDate.pastDue"
					text="Termin verschieben"
					smaller
					@click="moveAppointment"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import {LIST_TYPE__APPLICANT} from "@/store/communication/appointment";
import AppointmentInfos from "@/vue/communication/conversation/message/reply/AppointmentInfos";
import Button from "@/vue/common/Button";
import {mapActions} from "vuex";
import Icon from "@/vue/icon/Icon";

export default {

	components: {
		Icon,
		Button,
		AppointmentInfos,
	},

	props: {
		potentialDate: {
			type: Object,
			required: true,
		},
		listType: {
			type: String,
			required: true,
		},
	},

	computed: {
		classes ()
		{
			return {
				'communication-appointment-fan--appointment': true,
				'communication-appointment-fan--appointment-confirmed': this.potentialDate.confirmed
			};
		},
		isListTypeApplicant ()
		{
			return this.listType === LIST_TYPE__APPLICANT;
		},
		appointmentInfosType ()
		{
			return this.isListTypeApplicant
				? 'applicant'
				: 'customer';
		},
	},

	methods: {
		...mapActions('communication/appointment/move', {
			showMoveFan: 'show',
		}),
		moveAppointment ()
		{
			this.showMoveFan({
				potentialDate: this.potentialDate,
				listType: this.listType,
				onClose: ({confirmed}) =>
				{
					if (confirmed)
					{
						this.$emit('change');
					}
				}
			});
		},
	}
}
</script>
